import Immutable from 'immutable';
import {
  FLAG_GETTING_DRIVERS,
  GET_DRIVERS,
  CLEAR_DRIVERS,
  FLAG_DRIVER_ACTIVITY,
  CLEAR_DRIVER,
  GET_DRIVER,
  GET_DRIVER_TRIPS,
  CLEAR_DRIVER_TRIPS,
} from '../../../actions/types/traffic';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    trips: Immutable.Map(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DRIVERS:
      return state.setIn(['all', 'loading'], payload);
    case GET_DRIVERS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVERS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DRIVER_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DRIVER_TRIPS:
      return state.setIn(['current', 'trips'], Immutable.Map(payload));
    case CLEAR_DRIVER_TRIPS:
      return state.setIn(
        ['current', 'trips'],
        INITIAL_STATE.getIn(['current', 'trips']),
      );
    case GET_DRIVER:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVER:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
